export const CtaTiles = (() => {
	'use strict';

	function init() {

		var colors = [
			'red',
			'pink',
			'mid_green',
			'bright_green',
			'blue',
			'light_blue',
			'purple',
			'lavender'
		];

		// $('.tile a').on('mouseenter', function() {
		// 	var random_color = colors[Math.floor(Math.random()*colors.length)];
		// 	console.log(random_color);
		// 	$(this).attr('class', 'color--' + random_color);
		// });

	}

	return {
		init: init,
		name: 'cta-tiles'
	};
})();
